import {
  AlertTriangle,
  ArrowRight,
  Check,
  ChevronLeft,
  ChevronRight,
  ClipboardCheck,
  Command,
  Copy,
  CreditCard,
  File,
  FileText,
  Github,
  HelpCircle,
  Image,
  Laptop,
  Loader2,
  LucideProps,
  Moon,
  MoreVertical,
  Pizza,
  Plus,
  Settings,
  SunMedium,
  Trash,
  Twitter,
  User,
  X,
  GalleryHorizontal,
  LucideIcon,
} from "lucide-react";

import { GithubIcon } from "./github-icon";

export type Icon = LucideIcon;

export const Icons = {
  logo: GalleryHorizontal,
  close: X,
  copy: Copy,
  copyDone: ClipboardCheck,
  spinner: Loader2,
  chevronLeft: ChevronLeft,
  chevronRight: ChevronRight,
  trash: Trash,
  post: FileText,
  page: File,
  media: Image,
  settings: Settings,
  billing: CreditCard,
  ellipsis: MoreVertical,
  add: Plus,
  warning: AlertTriangle,
  user: User,
  arrowRight: ArrowRight,
  help: HelpCircle,
  pizza: Pizza,
  gitHub: GithubIcon,
  twitter: Twitter,
  check: Check,
  sun: SunMedium,
  moon: Moon,
  laptop: Laptop,
};
